export const MAX_CODE_AMOUNT = 1500;

export class PaycodeStatus {
  static readonly ACTIVE = 'active';
  static readonly BOUNCED = 'bounced';
  static readonly INACTIVE = 'inactive';
  static readonly COMPLETE = 'complete';
}

export class BalanceTransactionType {
  static readonly WIRE = 'wire';
  static readonly ACH = 'ach';
}
